import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { BRAND } from "../data/site";

const LINKS = [
  { label: "Oferta", to: "/oferta" },
  { label: "Szkolenia", to: "/szkolenia" },
  { label: "Dla agencji", to: "/dla-agencji" },
  { label: "Kontakt", to: "/kontakt" },
];

export const SubNav = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="subnav"
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-[background,backdrop-filter,border] duration-300 ${
        scrolled ? "bg-graphite/80 backdrop-blur-xl border-b border-white/10" : "border-b border-transparent"
      }`}
    >
      <nav className="container-pm flex items-center justify-between h-[72px]">
        <Link to="/" data-testid="subnav-logo" className="flex items-center">
          <img src={BRAND.logo} alt="PMPOINT" className="h-7 w-auto" width="140" height="28" />
        </Link>
        <div className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className="text-sm text-mutedfg hover:text-white transition-colors relative group"
              data-testid={`subnav-link-${l.to.replace("/", "")}`}
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-coral transition-all duration-300 group-hover:w-full" />
            </Link>
          ))}
        </div>
        <a
          href="/#aplikuj"
          data-testid="subnav-cta"
          className="inline-flex items-center gap-1.5 h-11 px-5 rounded-lg bg-coral text-white text-sm font-bold hover:bg-coral-hover hover:-translate-y-0.5 transition-all"
        >
          Aplikuj <ArrowUpRight size={16} />
        </a>
      </nav>
    </motion.header>
  );
};
